import { createApp, onMounted } from 'vue';
import common from '@page/common/js/common';
import $ from 'jquery';
import validate from '@global/vendors/jquery.validate.min';
import useAlert from '@global/composable/useAlert';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import { fireLoginEvent, fireLoginGTMEventByLINE } from '@global/gtm/login/login';
import { fireRegisterEvent, fireRegisterGTMEventByLINE } from '@global/gtm/login/register';

const { alertDialog } = useAlert();
const { postForgetPS, getAccountExist } = useAxiosAPI();

const app = createApp({
  setup() {
    onMounted(() => {
      $('.menu-type').on('click', function changeMenu(e) {
        e.preventDefault();
        const $el = $(this);
        const type = $el.data('type');

        $('.menu-type').removeClass('active');
        $el.addClass('active');
        $('.is-other-verify').removeClass('d-none');

        const isLogin = type === 'login';
        $('.form-block.is-login').toggle(isLogin);
        $('.form-block.is-register').toggle(!isLogin);

        const $forgotBlock = $('.form-block.is-forgot');

        if ($forgotBlock.length) {
          $forgotBlock.toggleClass('is-login is-forgot');
          $('.form-block.is-login').hide();
          $('#success-msg').hide();
        }
      });

      $('.btn-forget-pws').on('click', (e) => {
        e.preventDefault();

        $('.form-block.is-login').addClass('is-forgot');
        $('.form-block.is-forgot').removeClass('is-login');
        $('.is-other-verify').addClass('d-none');
      });

      $('.btn-line-login').on('click', function lineLogin() {
        if (this.parentElement.classList.contains('is-login')) {
          fireLoginGTMEventByLINE();
        } else {
          fireRegisterGTMEventByLINE();
        }
      });

      $.validator.addMethod(
        'regx',
        (value, element, regexpr) => {
          return regexpr.test(value);
        },
        '請輸入5碼至16碼英數字',
      );

      $('#form-register').validate({
        errorClass: 'error',
        errorElement: 'div',
        rules: {
          account: {
            required: true,
            email: true,
          },
          password: {
            required: true,
            // change regexp to suit your needs
            regx: /^(?=.*\d)(?=.*[A-Za-z])[^\s]{6,15}$/,
          },
          checkPassword: {
            required: true,
            equalTo: '#password-register',
          },
        },
        messages: {
          account: {
            required: '必填',
          },
          password: {
            required: '必填',
            regx: '6-15碼英數字',
          },
          checkPassword: {
            required: '必填',
            equalTo: '密碼不一致!',
          },
        },
        errorPlacement(error, element) {
          element.parent().append(error);
        },
        submitHandler(form) {
          const $btn = $(form).find("input[type='submit']");
          $btn.addClass('disabled');

          getAccountExist({
            params: {
              Account: $(form).find('input[name="account"]').val(),
            },
          })
            .then((res) => {
              if (res.data.Code === 200) {
                if (res.data.Response) {
                  // 帳號已經存在
                  alertDialog.alert(res.data.Message);
                } else {
                  form.submit();
                  fireRegisterEvent();
                }
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              $btn.removeClass('disabled');
            });

          return false;
        },
      });

      $('#form-login').validate({
        errorClass: 'error',
        errorElement: 'div',
        rules: {
          account: 'required',
          password: 'required',
        },
        messages: {
          account: {
            required: '請輸入會員帳號',
          },
          password: {
            required: '請輸入會員密碼',
          },
        },
        errorPlacement(error, element) {
          element.parent().append(error);
        },
        submitHandler(form) {
          form.submit();
          fireLoginEvent();
        },
      });

      $('#form-user-forgot').validate({
        errorClass: 'error',
        errorElement: 'div',
        rules: {
          account: {
            required: true,
          },
        },
        messages: {
          account: {
            required: '必填',
          },
        },
        errorPlacement(error, element) {
          element.parent().append(error);
        },
        submitHandler(form) {
          const $btn = $(form).find("input[type='submit']");
          $btn.addClass('disabled');

          postForgetPS(
            {
              Account: $(form).find('input[name="account"]').val(),
            },
            {
              handle500: true,
            },
          )
            .then((res) => {
              if (res.data.Code === 200) {
                $('#success-msg').css('display', 'block');
                $('.form-block').css('display', 'none');
              } else if (res.data.Code === 400) {
                $('#email-forgot')
                  .parent()
                  .append(`<div id="email-forgot-error" class="error">${res.data.Message}</div>`);
              } else if (res.data.Code === 500) {
                $('.form-block').empty();
                $('.form-block').attr('id', 'thirdParty');
                $('.form-block').append(`
                  <div class="third-block">
                  <div class="paragraph mb-2">
                      <p>${res.data.Description}</p>
                  </div>
                  <div class="paragraph regular">
                      <p>${res.data.Message}</p>
                  </div>
                  <div class="text-center">
                    <a class="btn btn-primary btn-block" href="/login">確認</a>
                  </div>
                </div>`);
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              $btn.removeClass('disabled');
            });
        },
      });
    });
  },
});

app.mount('#app-register');
